export default __webpack_public_path__ + "static/media/calender_active.53291852.svg";